import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import {
  Package,
  Factory,
  PackageCheck,
  PackageX,
  PackagePlus,
  DollarSign,
  ArrowDownUp,
  TrendingUp,
} from "lucide-react";

interface SeedOption {
  value: number;
  label: string;
}

interface FactoryOption {
  value: number;
  label: string;
}

const ReportPage: React.FC = () => {
  const [dataFactoryList, setDataFactoryList] = useState<any[]>([]);
  const [dataSeedList, setDataSeedList] = useState<any[]>([]);
  const [dataFactoryID, setDataFactoryID] = useState<number | null>(null);
  const [dataSeedID, setDataSeedID] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [reload, setReload] = useState(false);

  const [reportData, setReportData] = useState({
    total_received_pesticide_count_all: 0.0,
    total_pesticide_delivered_to_farmer_count_all: 0.0,
    total_remaining_pesticide_count_all: 0.0,
    total_pesticide_amount_paid_factory_all: 0.0,
    total_pesticide_amount_received_farmer_all: 0.0,
    total_contractor_pesticide_profit_all: 0.0,
    report_generated_at: "1404/04/31 15:17:39",
  });

  const cropYearID = localStorage.getItem("crop_year_id");
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();
  useEffect(() => {
    const featchData = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == cropYearID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    featchData();
  }, []);

  // Fetch factory options on component mount
  useEffect(() => {
    const fetchFactories = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get("https://api.havirkesht.ir/factory/", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setDataFactoryList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت لیست کارخانه‌ها:", error);
      }
    };

    fetchFactories();
  }, []);

  // Fetch seed options on component mount
  useEffect(() => {
    const fetchSeeds = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const headers = { Authorization: `Bearer ${token}` };
        const baseUrl = "https://api.havirkesht.ir/pesticide/?size=100";

        // پاسخ صفحه‌بندی شده است؛ بدون خواندن همه صفحات، فهرست سم‌ها ناقص می‌ماند
        const firstPage = await axios.get(`${baseUrl}&page=1`, { headers });
        let items = firstPage.data?.items || [];
        const totalPages = firstPage.data?.pages || 1;

        for (let page = 2; page <= totalPages; page++) {
          const nextPage = await axios.get(`${baseUrl}&page=${page}`, { headers });
          items = items.concat(nextPage.data?.items || []);
        }

        setDataSeedList(items);
      } catch (error) {
        console.error("خطا در دریافت لیست سم‌ها:", error);
      }
    };

    fetchSeeds();
  }, []);

  // Fetch report data when selections change
  useEffect(() => {
    const fetchReportData = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = localStorage.getItem("app_atkey");
        const body = {
          factory_id: dataFactoryID ? dataFactoryID : null,
          pesticide_id: dataSeedID ? dataSeedID : null,
        };
        const cropID = Number(localStorage.getItem("crop_year_id"));
        const response = await axios.post(
          `https://api.havirkesht.ir/report-pesticide/?crop_year_id=${cropID}`,
          body,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response, "response");

        setReportData({
          total_received_pesticide_count_all:
            response.data.total_received_pesticide_count_all || 0.0,
          total_pesticide_delivered_to_farmer_count_all:
            response.data.total_pesticide_delivered_to_farmer_count_all || 0.0,
          total_remaining_pesticide_count_all:
            response.data.total_remaining_pesticide_count_all || 0.0,
          total_pesticide_amount_paid_factory_all:
            response.data.total_pesticide_amount_paid_factory_all || 0.0,
          total_pesticide_amount_received_farmer_all:
            response.data.total_pesticide_amount_received_farmer_all || 0.0,
          total_contractor_pesticide_profit_all:
            response.data.total_contractor_pesticide_profit_all || 0.0,
          report_generated_at:
            response.data.report_generated_at || "1404/04/31 15:17:39",
        });
      } catch (err) {
        setError("خطا در دریافت گزارش");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [reload, dataFactoryID, dataSeedID]);

  // Trigger reload when filters change
  useEffect(() => {
    setReload(!reload);
  }, []);

  // تابع برای فرمت کردن اعداد با جداکننده هزارگان
  const formatNumber = (num: number) => {
    return num?.toLocaleString("fa-IR");
  };

  return (
    <div className="container mx-auto p-4 dark:bg-gray-900 dark:text-gray-100">
      <h1 className="text-2xl font-bold mb-6 text-right dark:text-white">
        گزارش سم
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="flex flex-col">
          <label className="text-base font-medium mb-1 dark:text-gray-300">
            نام کارخانه:
          </label>
          <Select
            options={[
              { value: null, label: "انتخاب همه..." },
              ...dataFactoryList.map((item) => ({
                value: item.id,
                label: item.factory_name,
              })),
            ]}
            defaultValue={{ value: null, label: "انتخاب همه..." }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({
                ...base,
                backgroundColor: "inherit",
              }),
              option: (base) => ({
                ...base,
                color: "inherit",
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
              }),
            }}
            menuPortalTarget={document.body}
            onChange={(selected: any) => setDataFactoryID(selected.value)}
            placeholder="جستجو..."
            noOptionsMessage={() => "داده‌ای یافت نشد"}
            className="w-full my-react-select-container dark:text-gray-900"
            classNamePrefix="my-react-select"
            isSearchable
          />
        </div>

        <div className="flex flex-col">
          <label className="text-base font-medium mb-1 dark:text-gray-300">
            نام سم:
          </label>
          <Select
            options={[
              { value: null, label: "انتخاب همه..." },
              ...dataSeedList.map((item) => ({
                value: item.id,
                label: item.pesticide_name,
              })),
            ]}
            defaultValue={{ value: null, label: "انتخاب همه..." }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({
                ...base,
                backgroundColor: "inherit",
              }),
              option: (base) => ({
                ...base,
                color: "inherit",
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
              }),
            }}
            menuPortalTarget={document.body}
            onChange={(selected: any) => setDataSeedID(selected.value)}
            placeholder="جستجو..."
            noOptionsMessage={() => "داده‌ای یافت نشد"}
            className="w-full my-react-select-container dark:text-gray-900"
            classNamePrefix="my-react-select"
            isSearchable
          />
        </div>
      </div>

      {loading && (
        <div className="text-center py-4 dark:text-gray-300">
          در حال دریافت داده‌ها...
        </div>
      )}

      {error && (
        <div className="bg-red-100 dark:bg-red-900 dark:bg-opacity-20 border border-red-400 dark:border-red-700 text-red-700 dark:text-red-300 px-4 py-3 rounded relative mb-4 text-right">
          {error}
        </div>
      )}

      {!loading && !error && (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold mb-6 dark:text-white text-right">
            {`  گزارش سم بر اساس سال زراعی ${YearCoptSelect}`}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* سم دریافتی */}
            <div className="bg-blue-50 dark:bg-blue-900 dark:bg-opacity-20 p-4 rounded-lg">
              <div className="flex items-center">
                <PackagePlus
                  className="text-blue-600 dark:text-blue-400 mr-2"
                  size={20}
                />
                <span className="font-medium dark:text-gray-300">
                  تعداد سم های دریافتی از کارخانه
                </span>
              </div>
              <p className="text-lg mt-2 dark:text-white">
                {formatNumber(reportData.total_received_pesticide_count_all)}
              </p>
            </div>

            {/* سم تحویل داده شده */}
            <div className="bg-green-50 dark:bg-green-900 dark:bg-opacity-20 p-4 rounded-lg">
              <div className="flex items-center">
                <PackageCheck
                  className="text-green-600 dark:text-green-400 mr-2"
                  size={20}
                />
                <span className="font-medium dark:text-gray-300">
                  تعداد سم های تحویل داده شده به کشاورز
                </span>
              </div>
              <p className="text-lg mt-2 dark:text-white">
                {formatNumber(
                  reportData.total_pesticide_delivered_to_farmer_count_all
                )}
              </p>
            </div>

            {/* سم باقیمانده */}
            <div className="bg-yellow-50 dark:bg-yellow-900 dark:bg-opacity-20 p-4 rounded-lg">
              <div className="flex items-center">
                <PackageX
                  className="text-yellow-600 dark:text-yellow-400 mr-2"
                  size={20}
                />
                <span className="font-medium dark:text-gray-300">
                  تعداد سم های باقی مانده
                </span>
              </div>
              <p className="text-lg mt-2 dark:text-white">
                {formatNumber(reportData.total_remaining_pesticide_count_all)}
              </p>
            </div>

            {/* پرداختی به کارخانه */}
            <div className="bg-purple-50 dark:bg-purple-900 dark:bg-opacity-20 p-4 rounded-lg">
              <div className="flex items-center">
                <DollarSign
                  className="text-purple-600 dark:text-purple-400 mr-2"
                  size={20}
                />
                <span className="font-medium dark:text-gray-300">
                  کل مبلغ پرداختی سم به کارخانه
                </span>
              </div>
              <p className="text-lg mt-2 dark:text-white">
                {formatNumber(
                  reportData.total_pesticide_amount_paid_factory_all
                )}{" "}
                تومان
              </p>
            </div>

            {/* دریافتی از کشاورز */}
            <div className="bg-teal-50 dark:bg-teal-900 dark:bg-opacity-20 p-4 rounded-lg">
              <div className="flex items-center">
                <ArrowDownUp
                  className="text-teal-600 dark:text-teal-400 mr-2"
                  size={20}
                />
                <span className="font-medium dark:text-gray-300">
                  کل مبلغ دریافت شده بابت سم از کشاورزان
                </span>
              </div>
              <p className="text-lg mt-2 dark:text-white">
                {formatNumber(
                  reportData.total_pesticide_amount_received_farmer_all
                )}{" "}
                تومان
              </p>
            </div>

            {/* سود پیمانکار */}
            <div className="bg-emerald-50 dark:bg-emerald-900 dark:bg-opacity-20 p-4 rounded-lg">
              <div className="flex items-center">
                <TrendingUp
                  className="text-emerald-600 dark:text-emerald-400 mr-2"
                  size={20}
                />
                <span className="font-medium dark:text-gray-300">
                  سود پیمانکار در سم
                </span>
              </div>
              <p className="text-lg mt-2 dark:text-white">
                {formatNumber(reportData.total_contractor_pesticide_profit_all)}{" "}
                تومان
              </p>
            </div>
          </div>

          {/* <div className="mt-4 text-sm text-gray-500 dark:text-gray-400 text-right">
            تاریخ تولید گزارش: {reportData.report_generated_at}
          </div> */}
        </div>
      )}
    </div>
  );
};

export default ReportPage;
